import { render, staticRenderFns } from "./Fornecedores.vue?vue&type=template&id=29b8cdf4"
import script from "./Fornecedores.vue?vue&type=script&lang=js"
export * from "./Fornecedores.vue?vue&type=script&lang=js"
import style0 from "./Fornecedores.vue?vue&type=style&index=0&id=29b8cdf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports